import moment from 'moment';
import { isMoment, Moment } from 'moment';
import React, { useMemo } from 'react';
import { useAppContext } from '../../../../Services/AppContext';

export enum DateFormat {
	DATE = 'date',
	TIME = 'time',
	DATE_TIME = 'dateTime',
}

interface Props {
	date: string | Moment;
	format: DateFormat;
}

const FormattedMomentDate: React.FC<Props> = ({ date, format }) => {
	const { dateFormatMoment } = useAppContext();
	const formattedDate = useMemo(() => {
		const dateInMoment = isMoment(date) ? date : moment(date);
		switch (format) {
			case DateFormat.DATE:
				return dateInMoment.format(dateFormatMoment);
			case DateFormat.TIME:
				return dateInMoment.format('HH:mm');
			case DateFormat.DATE_TIME:
				return dateInMoment.format(dateFormatMoment + ', HH:mm');
		}
	}, [date]);

	return <>{formattedDate}</>;
};

export default FormattedMomentDate;
